import { useEffect, useState } from 'react';

/** Esc closes what is open inside first: a field being typed in, a form, a dialog. */
const inside = (t: EventTarget | null) => t instanceof HTMLElement && (t.isContentEditable || ['INPUT', 'TEXTAREA', 'SELECT'].includes(t.tagName) || t.closest('[role="dialog"], form') !== null);

/** The window a large drawing takes in full screen, over everything but feedback; its layout is the caller's. */
export const FULL_SCREEN = 'fixed inset-0 z-[70] overflow-hidden bg-paper px-4 pb-4 pt-3';

/**
 * A large drawing given the whole window (Jason, 2026-10-04: "these large
 * canvas things should have a full screen mode button that uses all the
 * available realestate width wise"); Esc gives the page back. The page under
 * it keeps still while it is open.
 */
export function useFullScreen(): [boolean, (on: boolean) => void] {
  const [full, setFull] = useState(false);
  useEffect(() => {
    if (!full) return;
    const key = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && !e.defaultPrevented && !inside(e.target)) setFull(false);
    };
    const was = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', key);
    return () => {
      window.removeEventListener('keydown', key);
      document.body.style.overflow = was;
    };
  }, [full]);
  return [full, setFull];
}
